<template>
  <router-view></router-view>
</template>

<style>
.dx-prevent-safari-scrolling{
  position: relative !important;
}

#app {
  font-family: "Open Sans", Calibri, Candara, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.center {
  margin: auto;
  width: 80%;
  padding: 10px;
}
.backgroudlist {
  background-color: #49c0de;
}
.backgroudlistwhite {
  background-color: white;
}
.titolo {
  font-family: Arial, Helvetica, sans-serif;
  font-style: oblique;
  font-size: 15px;
  font-weight: bold;
  color: #000000;
}
.testonormale {
  font-family: Verdana, Arial, Helvetica, sans-serif;
  font-size: 8pt;
  text-align: justify;
  color: Black;
}
.testobold {
  font-family: Verdana, Arial, Helvetica, sans-serif;
  font-size: 8pt;
  text-align: justify;
  color: Black;
  font-weight: bold;
}
.testoblu {
  font-family: Arial, Helvetica, sans-serif;
  font-style: oblique;
  font-size: 15px;
  font-weight: bold;
  color: #0099b1;
}

.testonormalecentrato {
  font-family: Verdana, Arial, Helvetica, sans-serif;
  font-size: 8pt;
  text-align: center;
}

.testocentrato {
  font-family: Verdana, Arial, Helvetica, sans-serif;
  text-align: center;
}

.titolorosso {
  font-family: Verdana, Arial, Helvetica, sans-serif;
  color: #cc0000;
  font-size: 12px;
  font-weight: bold;
}
.testoblu {
  font-family: Arial, Helvetica, sans-serif;
  font-style: oblique;
  font-size: 15px;
  font-weight: bold;
  color: #0099B1;
}
.testobianco {
	font-family: Arial, Helvetica, sans-serif;
	font-style: oblique;
	font-size:	15px;
	font-weight: bold;
	color: #FFFFFF;
	}

.link {
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}

.bold {
  font-weight: bold;
}
.regular {
  font-weight: normal;
}

.centerElement {
  width:100%;
  display: flex;
  justify-content: center;
}

button {
  height: 30px;
  width: 100px;
  
}
</style>
